import "./css/Schema.css";
import { Link } from "react-router-dom";
import { useState } from "react";
import schedule from "../content/schedule";

function Schema() {
    const [openDay, setOpenDay] = useState(
        schedule.map((_, index) => index)
    );
    const [openEvent, setOpenEvent] = useState(null);
    
    return (
        <section className="schema">

            <h1>Schema</h1>

            {schedule.map((day, dayIndex) => (

                <div key={dayIndex} className="day">

                    <div
                        className="day-title"
                        onClick={() => {
                            if (openDay.includes(dayIndex)) {
                                setOpenDay(openDay.filter(day => day !== dayIndex));
                            } else {
                                setOpenDay([...openDay, dayIndex]);
                            }
                        }}
                    >
                        {day.day}
                    </div>

                    {openDay.includes(dayIndex) && (

                        <div className="day-events">

                            {day.events.map((event, eventIndex) => {

                                const id = `${dayIndex}-${eventIndex}`;

                                return (

                                    <div
                                        key={id}
                                        className="event-card"
                                        onClick={() =>
                                            setOpenEvent(openEvent === id ? null : id)
                                        }
                                    >

                                        <div className="event-time">
                                            {event.time}
                                        </div>

                                        <div className="event-title">
                                            {event.title}
                                        </div>

                                        <div className="event-place">
                                            {event.place}
                                        </div>

                                        {openEvent === id && (

                                            <div className="event-details">

                                                <p>{event.description}</p>

                                            </div>

                                        )}

                                    </div>

                                );

                            })}

                        </div>

                    )}

                </div>

            ))}

        </section>
    );
}

export default Schema;